module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('error-page')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dfab2d2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Err.vue
// module id = 621
// module chunks = 2